import React from 'react';
import { useAuth } from '@features/auth/hooks/useAuth';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { APIProvider } from '@vis.gl/react-google-maps';
import config from '@config';
import client from '@apollolocal/client';
import MuiThemeProvider from '@muilocal/MuiThemeProvider';
import Layout from '@features/layout/components/Layout';
import AppRoutes from './Routes';
import { ErrorBoundary } from 'react-error-boundary';
import DefaultErrorFallback from '@components/Fallbacks/DefaultErrorFallback';
import { BuildBadge } from '@components/BuildBadge';

// Inner component that uses hooks requiring Router context
const AppContent: React.FC = () => {
  const { loading } = useAuth();

  return (
    <ApolloProvider client={client}>
      {/* The app's only Maps provider: every map needs it above it, including the product
          header's dialogs, which the shell mounts outside any tab. */}
      <APIProvider apiKey={config.googleApiKey}>
        <Layout>{!loading && <AppRoutes />}</Layout>
        <BuildBadge fixed />
      </APIProvider>
    </ApolloProvider>
  );
};

const App: React.FC = () => {
  return (
    <ErrorBoundary
      FallbackComponent={DefaultErrorFallback}
      onError={(error, info) => {
        // Log the error to your error reporting service here
        console.error('Uncaught error:', error, info);
      }}
    >
      <MuiThemeProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </MuiThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
